function Home() {
  window.location.replace('https://virtual.eventxtra.com');
  return null;
}

export default Home;
